import { render, staticRenderFns } from "./StartEnd.vue?vue&type=template&id=6a24ca39&lang=pug"
import script from "./StartEnd.vue?vue&type=script&lang=js"
export * from "./StartEnd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports